import { ClassFlag } from "../../dom-tools/ClassFlag";

export class DirectionFlags
{
  static readonly horizontal = new ClassFlag( "ui--horizontal" );
  static readonly vertical   = new ClassFlag( "ui--vertical" );
}